export interface StreamCompletedInterface {
    id: number;
    streamId: number;
    streamTitle: string;
    userId: number;
    points?: number;  // The '?' indicates that the property is optional
    dateAndTime: Date;
    submissionText?: string;  // Optional property
}

export class StreamCompleted implements StreamCompletedInterface {
    public id: number;
    public streamId: number;
    public streamTitle: string;
    public userId: number;
    public points?: number;
    public dateAndTime: Date;
    public submissionText?: string;

    // Constructor to initialize properties
    constructor(
        id: number,
        streamId: number,
        streamTitle: string,
        userId: number,
        dateAndTime: Date,
        points?: number,
        submissionText?: string
    ) {
        this.id = id;
        this.streamId = streamId;
        this.streamTitle = streamTitle;
        this.userId = userId;
        this.points = points;
        this.dateAndTime = dateAndTime;
        this.submissionText = submissionText;
    }

    static fromJson(json: any): StreamCompleted {
        return new StreamCompleted(
            json.id,
            json.streamId,
            json.streamTitle,
            json.userId,
            json.dateAndTime ? new Date(json.dateAndTime) : new Date(), // fallback to avoid invalid Date
            json.points,
            json.submissionText
        );
    }

    static fromJsonArray(jsonArray: any[]): StreamCompleted[] {
        return jsonArray.map(item => StreamCompleted.fromJson(item));
    }
}
